import { Menu, Transition } from '@headlessui/react';
import { ChevronRightIcon } from '@heroicons/react/20/solid';
import React, { FC, Fragment } from 'react';

type selectOption = {
  selected?: any;
  ListData: any;
  onChange: (data: any) => void;
};

const SelectOption: FC<selectOption> = ({ selected, ListData, onChange }) => {
  return (
    <div className="flex w-full z-[9999]">
      <Menu as="div" className="relative inline-block text-left w-full">
        <div className="w-full">
          <Menu.Button className="group inline-flex justify-between text-sm font-medium text-gray-700 hover:text-gray-900 w-full">
            {selected?.name}
            <ChevronRightIcon
              className="-mr-1 ml-1 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500"
              aria-hidden="true"
            />
          </Menu.Button>
        </div>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute right-0 z-[9999999] mt-2 w-40 origin-top-left rounded-md bg-white shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="py-1 flex justify-center overflow-auto max-h-64">
              <div>
                {ListData.map((option: any, index: number) => (
                  <Menu.Item key={index}>
                    {({ active }) => (
                      <div
                        className={`${
                          active ? 'bg-gray-100' : ''
                        } cursor-pointer block px-4 py-2 text-sm font-medium text-gray-900`}
                        onClick={() => {
                          onChange(option);
                          //   setOffset(0);
                          //   setContacts([]);
                          //   setSortBy({ name: option.name, value: option.value });
                        }}
                        onKeyDown={(e) => {
                          // Handle keyboard events, e.g., Enter key
                          if (e.key === 'Enter') {
                            // setOffset(0);
                            // setContacts([]);
                            // setSortBy({ name: option.name, value: option.value });
                          }
                        }}
                        role="button"
                        tabIndex={0}
                      >
                        {option.name}
                      </div>
                    )}
                  </Menu.Item>
                ))}
              </div>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};

export default SelectOption;
